const concat = "<br />"

const aboutnavi25 = {
    "About the Issue – Navi Finserv Oct’25": [
        {
          question: "Details of the Issue",
          answer:"Issuer Name: <b>Sagittarius Trust 08 2022</b>" + concat +
          "Series: <b>Series A2 PTC</b>" + concat +
          "Security Name: <b>SAGITTARIUS TRUST 08 2022 SERIES A2 PTC 30OCT23</b>" + concat +
          "ISIN: <b>INE0RS015026</b>" + concat +
          "Nature of Instrument: <b>Listed Secured</b>" + concat +
          "Seniority: <b>Subordinated Tranche (Series A2)</b>" + concat +
          "Original Mode of Issue: <b>Private Placement</b>" + concat +
          "Date of Issue: <b>30th Oct, 2023</b>" + concat +
          "Credit Rating: <b>AA- (SO) by India Ratings</b>" + concat +
          "Face Value: <b>Rs 1 per unit</b>" + concat +
          "Coupon: <b>Fixed</b>" + concat +
          "Coupon Rate: <b>9.11% p.a.</b>" + concat +
          "Coupon Frequency: <b>Monthly</b>" + concat +
          "Principal Repayment: <b>22nd, 23rd, 24th Month</b>" + concat +
          "Original Mode of Issue: <b>Private Placement</b>" + concat +
          "Listing Details: <b>Bombay Stock Exchange (BSE)</b>" + concat +
          "Expected Date of Maturity/ Tenor: <b>25 th Oct, 2025/ ~24 Months</b>" + concat +
          "Transaction Structure: <b>Ultimate Interest and Ultimate Principal (UIUP)</b>" + concat
        },
        {
          question: "Parties to the Issue",
          answer:"Originator: <b>Navi Finserv Limited</b>" + concat +
          "First Loss Credit Enhancer: <b>Navi Finserv Limited</b>" + concat +
          "Residual Beneficiary: <b>Navi Finserv Limited</b>" + concat +
          "Servicer: <b>Navi Finserv Limited</b>" + concat +
          "Alternate Servicer: <b>SBFC Finance Limited</b>" + concat +
          "Debenture Trustee: <b>Catalyst Trusteeship Limited</b>" + concat +
          "Rating Agency: <b>India Ratings</b>" + concat
        },
        {
          question: "What are the Credit Enhancement Measures for the issue?",
          answer: "For Series A2 PTC, the internal Credit Enhancement (CE) arises in the form of over-collateralisation and excess interest spread of 18.0% and 35.4%, respectively, of the initial Principal Outstanding (POS)." + concat + 
           "The total available external CE in the transaction is 2.0% of the initial POS. The CE is proposed to be provided in the form of fixed deposits held in the name of the trust and it is to be held with bank rated ‘AAA’." + concat
        },
        {
          question: "Details of the Loan Pool",
          answer: "Initial Pool Principal: Rs. 122.42 Cr" + concat + 
          "PTC Amount (Series A1): Rs. 90.59 Cr" + concat + 
          "PTC Amount (Series A2): Rs. 9.79 Cr" + concat + 
          "Over Collateral Amount: Rs. 22.03 Cr" + concat + 
          "Replenishment Period: 6 Months" + concat + 
          "Initial Pool Cash Flows: Rs. 167.98 Cr" + concat + concat + 
          "- Granular Pool with 9,309 loans with all being Personal Loans with average current outstanding loan balance of Rs. 131,518" + concat + 
          "- Pool has an aggregate outstanding principal balance of Rs. 122.43 Cr" + concat + 
          "- Weighted avg. credit score of the pool is 735.7" + concat + 
          "- Weighted avg. yield (IRR) on the pool is 26.0%" + concat + 
          "- The pool has a weighted avg. seasoning of 8.7 months as on cut-off date" + concat + 
          "- 100% of the pool include borrowers with NACH/E-Mandate as repayment mode" + concat 
        },
        {
          question: "Can I liquidate the PTC before maturity?",
          answer: "Yes, you can liquidate the PTC before maturity through our anytime liquidation feature. However, the liquidation will happen at a discount of 2% to the value of the PTC."
        },
        {
          question: "How is the Yield to Maturity (YTM) is calculated?",
          answer: "The Yield to Maturity is calculated using the XIRR formula present in Microsoft Excel or such other spreadsheets. The cash flow is populated in the spreadsheet along with the dates and the XIRR formula is then applied to get the YTM."
        }
      ],
  }
  
  export default aboutnavi25;